<template>
  <div>
    <ul class="colors">
      <span
        v-if="isProcessing"
        class="d-inline-block"> <i class="fa  fa-refresh fa-spin "/> </span>
      <li
        v-for="item in colorsDefault"
        :key="item"
        class="item"
        @click="selectColor(item)"
      >
        <div
          :style="{ background: `url(${imgAlphaBase64})` }"
          class="alpha"
        />
        <div
          :style="{ background: item }"
          class="color"
        />
      </li>
    </ul>

  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  props:  {
    color: {
      type:    String,
      default: '#000000',
    },
    colorsDefault: {
      type:    Array,
      default: [],
    },
    isProcessing: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgAlphaBase64:   '',
      colorsHistoryKey: 'bm-colorpicker-history',
    };
  },
  created() {
    this.imgAlphaBase64 = this.createAlphaSquare(4).toDataURL();
  },
  destroyed() {
    this.setColorsHistory(this.color);
  },
  methods: {
    selectColor(color) {
      this.$emit('selectColor', color);
    },
    setColorsHistory(color) {
      if (!color) {
        return;
      }
      const colors = JSON.parse(localStorage.getItem(this.colorsHistoryKey)) || [];
      const index  = colors.indexOf(color);
      if (index >= 0) {
        colors.splice(index, 1);
      }
      if (colors.length >= 8) {
        colors.length = 7;
      }
      colors.unshift(color);
      this.colorsHistory = colors;
      localStorage.setItem(this.colorsHistoryKey, JSON.stringify(colors));
    },
  },
};
</script>
